export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"Proveedor especializado en pinturas industriales en México. Soluciones profesionales para flotillas, construcción e industria. Solicite su cotización."},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#dc2626"}],"link":[{"rel":"preconnect","href":"https://fjwtxizdpgdhgxakcdzq.supabase.co","crossorigin":""},{"rel":"dns-prefetch","href":"https://fjwtxizdpgdhgxakcdzq.supabase.co"},{"rel":"preload","href":"/logo-acoxpa.png","as":"image","type":"image/png"}],"style":[],"script":[],"noscript":[],"title":"Pinturas Acoxpa - Granados Pinturas Industriales","htmlAttrs":{"lang":"es-MX"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt","class":"isolate"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true